import { render } from "./ClientsLoader.vue?vue&type=template&id=1a749e3a&ts=true"
import script from "./ClientsLoader.vue?vue&type=script&lang=ts"
export * from "./ClientsLoader.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__